import { render, staticRenderFns } from "./AnalysisDuration.vue?vue&type=template&id=236f0905&scoped=true&"
import script from "./AnalysisDuration.vue?vue&type=script&lang=js&"
export * from "./AnalysisDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f0905",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236f0905')) {
      api.createRecord('236f0905', component.options)
    } else {
      api.reload('236f0905', component.options)
    }
    module.hot.accept("./AnalysisDuration.vue?vue&type=template&id=236f0905&scoped=true&", function () {
      api.rerender('236f0905', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/AnalysisDuration.vue"
export default component.exports